'use strict'

class CustomMap {
    constructor() {
        this.body = document.querySelector('body');
        this.map = document.querySelector('.sl-Map');
        if (this.map) {
            this.mapContainer = this.map.querySelector('.mapContainer');
            this.crossMaps = this.map.querySelector('.mapCross');
            this.cursor = this.map.querySelector('#mapCursor');
            this.gMaps = this.mapContainer.querySelector('#map');
            this.mapHeader = this.mapContainer.querySelector('.header');
            this.fpNav = document.querySelector('#fp-nav');
            this.header = document.querySelector('#header');
        }
    }
    display() {
        // disable scrolling on fullpage
        fullpage_api.setAllowScrolling(false);
        this.fpNav.style.zIndex = '-1';
        this.header.style.zIndex = '-1';
        this.gMaps.classList.add('map-displayed');
        this.crossMaps.classList.add('cross-displayed');
        this.mapHeader.classList.add('header--mapEnabled');
        document.addEventListener('keydown', (event) => this.handleEscKey(event));
    }
    hide() {
        fullpage_api.setAllowScrolling(true);
        this.fpNav.style.zIndex = '';
        this.header.style.zIndex = '';
        this.gMaps.classList.remove('map-displayed');
        this.crossMaps.classList.remove('cross-displayed');
        this.mapHeader.classList.remove('header--mapEnabled');
        // force maps popin hiding
        document.querySelector('.maps-popin').style.display = 'none';
    }
    toggleDisplay() {
        if (this.map) {
            this.crossMaps.addEventListener('click', () => this.hide());
            this.mapContainer.addEventListener('click', () => this.display());
        }
    }
    setCursor() {
        // set custom cursor
        if (this.map && this.cursor) {
            this.mapContainer.onmousemove = (e) => {

                if (document.querySelector('.map-displayed')) {
                    this.body.style.cursor = '';
                }
                else {
                    this.body.style.cursor = 'none';
                    this.cursor.style.top = `${e.clientY - 19}px`;
                    this.cursor.style.left = `${e.clientX - 19}px`;
                }
            }
            this.mapContainer.onmouseleave = () => this.body.style.cursor = '';
        }
    }
    handleEscKey(event) {
        const key = event.key
        if (key === "Escape" || key === "Esc") { /* Firefox Chrome === Escape / IE11 === Esc */
            this.hide();
        }
    }
}

export default CustomMap


// WEBPACK FOOTER //
// ./src/scripts/components/CustomMap.js